<template>
  <div class="link-wrap">
    <!--lastExamResult 上次考试结果，0-未考过、1-及格、2-不及格 -->
    <template v-if="item.times === 1">
      <el-link :href="item.examUrl" class="button" target="_blank" title="开始答题" :disabled="!userInfo.username" :class="{'vs-disabled': !userInfo.username}" v-if="!deadlineTimeout(item.deadline) && item.examUrl && item.lastExamResult === 0">开始答题</el-link>
      <el-link :href="item.analysisUrl" class="button info" target="_blank" title="答题解析" :disabled="!userInfo.username" :class="{'vs-disabled': !userInfo.username}" v-if="item.analysisUrl && (item.lastExamResult === 2 || item.lastExamResult === 1 || deadlineTimeout(item.deadline))">答题解析</el-link>
    </template>
    <template v-else-if="item.times === 999">
      <el-link :href="item.examUrl" class="button" target="_blank" title="开始答题" :disabled="!userInfo.username" :class="{'vs-disabled': !userInfo.username}" v-if="!deadlineTimeout(item.deadline) && item.examUrl && item.lastExamResult === 0">开始答题</el-link>
      <el-link :href="item.examUrl" class="button" target="_blank" title="再考一次" :disabled="!userInfo.username" :class="{'vs-disabled': !userInfo.username}" v-if="!deadlineTimeout(item.deadline) && item.examUrl && (item.lastExamResult === 1 || item.lastExamResult === 2)">再考一次</el-link>
      <el-link :href="item.analysisUrl" class="button info" target="_blank" title="答题解析" :disabled="!userInfo.username" :class="{'v-disabled': !userInfo.username}" v-if="item.analysisUrl && (item.lastExamResult === 1 || item.lastExamResult === 2 || deadlineTimeout(item.deadline))">答题解析</el-link>
    </template>
    <template v-else>
      <el-link :href="item.examUrl" class="button" target="_blank" title="开始答题" :disabled="!userInfo.username" :class="{'vs-disabled': !userInfo.username}" v-if="!deadlineTimeout(item.deadline) && item.examUrl && item.lastExamResult === 0">开始答题</el-link>
      <el-link :href="item.examUrl" class="button" target="_blank" title="开始答题" :disabled="!userInfo.username" :class="{'vs-disabled': !userInfo.username}" v-if="!deadlineTimeout(item.deadline) && item.examUrl && item.lastExamResult === 2 && item.makeupCount > 0">{{`不及格，还能补考${item.makeupCount}次`}}</el-link>
      <el-link :href="item.analysisUrl" class="button info" target="_blank" title="答题解析" :disabled="!userInfo.username" :class="{'vs-disabled': !userInfo.username}" v-if="item.analysisUrl && (item.lastExamResult === 2 || item.lastExamResult === 1 || deadlineTimeout(item.deadline))">答题解析</el-link>
    </template>
  </div>
</template>

<script>
import { ElLink } from 'element-plus'
import {mapState} from 'vuex'
export default {
  props: {
    item: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  computed: {
    ...mapState(['userInfo'])
  },
  methods: {
    deadlineTimeout (item) {
      if (item && Date.now() > item && item > new Date('2000/01/01 00:00:00').getTime()) {
        return true
      }
      return false
    }
  },
  components: {
    ElLink
  }
}
</script>


<style lang="scss" scoped>
.link-wrap{
  text-align: right;
  .button {
    display: inline-block;
    font-weight: 400;
    font-size: 14px;
    line-height: 22px;
    text-align: center;
    background-color:#FD3374;
    color: #fff;
    min-width: 104px;
    height: 34px;
    line-height: 34px;
    border-radius: 20px;
    margin-top: 35px;
    padding: 0 10px;
    margin-left: 10px;
    &.info {
      border: 1px solid #D3D6DA;
      background: #fff;
      color:#666;
    }
  }
}
</style>